module.exports = __webpack_public_path__ + "static/media/doctoru.87395334.png";